if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.initBis();
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      const formData = new FormData(this.form);

      if (window.settings && window.settings.limitedQuantityPerOrder) {
        var variantId = formData.get('id');
        var variantQuantity = formData.get('quantity') || 1;
        var variantLimitedQuantities = window.settings.limitedQuantityPerOrder;
        var itemQuantities = this.cartItems.getItemQuantities();

        if ((itemQuantities[variantId] + variantQuantity) > variantLimitedQuantities[variantId]) {
          var dialog = document.getElementById('limited_quantity_per_order__dialog');
          dialog.querySelector('.limited_quantity_per_order__copy').innerHTML = dialog.querySelector('.limited_quantity_per_order__copy').innerHTML.replace('[max_quantity]', variantLimitedQuantities[variantId]);
          dialog.showModal();
          return;
        }
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      if(document.querySelector('floating-form')) {
        document.querySelector('floating-form [type="submit"]').classList.add('loading');
        document.querySelector('floating-form [type="submit"]').setAttribute('aria-disabled', true);
        document.querySelector('floating-form .loading-overlay__spinner')?.classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const renderAndReconcile = async () => {
            this.cart.renderContents(response);
            await FreeSample.reconcileActiveCart?.();
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          };
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                renderAndReconcile();
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            await renderAndReconcile();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          if(document.querySelector('floating-form')) {
            document.querySelector('floating-form [type="submit"]').classList.remove('loading');
            document.querySelector('floating-form [type="submit"]').removeAttribute('aria-disabled');
            document.querySelector('floating-form .loading-overlay__spinner')?.classList.add('hidden');
          }
        });
    }

    initBis() {
      this.bisPop = this.querySelector('.klaviyo-bis-popup[data-function="listSubscribe"]');
      this.bisSumbit = this.querySelector('.bis_submit');
      this.bisOpen = this.querySelectorAll('.klaviyo-bis-trigger');
      if (!this.bisPop || !this.bisSumbit || this.bisOpen.length === 0) return;

      this.bisOpen.forEach(btn => {btn.addEventListener('click', this.onBisToggle.bind(this))});
      this.bisSumbit.addEventListener('click', this.onComingSoonSubmit.bind(this));
      this.querySelectorAll('.klaviyo-bis-close').forEach(close => {close.addEventListener('click', this.onBisToggle.bind(this))});
    }

    onBisToggle(e) {
      this.bisPop && this.bisPop.classList.toggle('hidden');
    }

    onComingSoonSubmit(e) {
      const email = this.querySelector('[name="email"]').value;
      const newsletter = this.querySelector('[name="newsletter_list"]').checked;
      console.log(email, newsletter);
      if (email.length > 0) {
        const klaviyo = new Klaviyo()
        .listSubscribe(email, window.klaviyo.comingSoonListId)
        .then(response => {
          console.log(response);
          if (response.status == 202) {
            this.querySelector('#sdg-restock-notification-msg-success').classList.remove('hidden');
            this.querySelector('#sdg-restock-notification-msg-error').classList.add('hidden');
            this.querySelector('.bis_field_container').classList.add('hidden');
            if (newsletter) {
              new Klaviyo().listSubscribe(email, window.klaviyo.newsletterListId)
            }
          } else {
            this.querySelector('#sdg-restock-notification-msg-error').classList.remove('hidden');
            this.querySelector('#sdg-restock-notification-msg-success').classList.add('hidden');
          }
        })

      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        console.log(errorMessage);
        if (typeof errorMessage === 'string') {
          this.errorMessage.innerHTML = errorMessage;
        } else {
          this.errorMessage.innerHTML = `
            <ul>
              ${Object.entries(errorMessage).map((error) => {
                let errorField = error[0];
                let errorMessage = error[1];
                return `<li>${errorField} ${errorMessage}</li>`;
              })}
            </ul>
          `;
        }
      }
    }
  });
}
